// collection page top slider popup script
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.open-modal-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const id = this.getAttribute('data-block-id');
      document.getElementById(`modal-${id}`).style.display = 'flex';
    });
  });

  document.querySelectorAll('.close-modal').forEach(closeBtn => {
    closeBtn.addEventListener('click', function () {
      const id = this.getAttribute('data-block-id');
      document.getElementById(`modal-${id}`).style.display = 'none';
    });
  });

  // Optional: close on outside click
  document.querySelectorAll('.custom-modal').forEach(modal => {
    modal.addEventListener('click', function (e) {
      if (e.target === this) this.style.display = 'none';
    });
  });
});



// bundleset products



document.addEventListener('DOMContentLoaded', function () {
  // Quantity +/- Buttons
  document.querySelectorAll('.qty-plus').forEach(btn => {
    btn.addEventListener('click', function () {
      const id = this.dataset.productId;
      const input = document.querySelector(`input[name="quantity_${id}"]`);
      input.value = parseInt(input.value || 0) + 1;
    });
  });

  document.querySelectorAll('.qty-minus').forEach(btn => {
    btn.addEventListener('click', function () {
      const id = this.dataset.productId;
      const input = document.querySelector(`input[name="quantity_${id}"]`);
      const current = parseInt(input.value || 0);
      if (current > 0) input.value = current - 1;
    });
  });

  // Submit Form
  const form = document.getElementById('bundle-product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const button = form.querySelector('.bundle-add-to-cart-button'); // Or use form.querySelector('button[type="submit"]')
      toggleLoading(true, button); // Start spinner

      const items = [];
      const productBlocks = form.querySelectorAll('.bundle-product');
      const cartDrawer = document.querySelector('m-cart-drawer');
      const errorWrapper = document.querySelector('.product-bundleset__error');


      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      productBlocks.forEach(product => {
        const productId = product.dataset.productId;
        const quantityInput = product.querySelector(`input[name="quantity_${productId}"]`);
        const quantity = parseInt(quantityInput?.value || 0);

        const selectedVariant = product.querySelector(`input[name="variant_${productId}"]:checked`);
        const variantId = selectedVariant?.value;

        if (variantId && quantity > 0) {
          items.push({
            id: parseInt(variantId),
            quantity: quantity
          });
        }
      });

      if (items.length === 0) {
        if (errorWrapper) {
          errorWrapper.innerHTML = '<p class="bundle-error-message">Please specify the quantity of product(s).</p>';
          errorWrapper.style.display = 'block';
        }
        toggleLoading(false, button); // Stop spinner
        return;
      } else {
        if (errorWrapper) {
          errorWrapper.innerHTML = '';
          errorWrapper.style.display = 'none';
        }
      }

      let data = {
        items,
        sections: sectionsToBundle,
        sections_url: window.location.pathname,
      };

      const config = fetchConfig("javascript");
      config.method = "POST";
      config.body = JSON.stringify(data);

      // Add to Cart via Ajax
      const { wcmmgSettings, wcmmgStrings } = window;
      fetch(`${wcmmgSettings.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(response => {
          if (response.status) {
            console.log(response.description || "Failed to add all items to cart!", errorWrapper);
            //this._showError(response.description || "Failed to add all items to cart!", errorWrapper);
            document.dispatchEvent(
              new CustomEvent("product-ajax:error", {
                detail: {
                  errorMessage: response.description,
                },
              })
            );
            return;
          }
          if (wcmmgSettings.use_ajax_atc) {
            if (cartDrawer && wcmmgSettings.enable_cart_drawer) {
              wcmmgTheme.Notification.show({
                target: cartDrawer.querySelector("m-cart-items"),
                method: "prepend",
                type: "success",
                message: wcmmgStrings.itemAdded,
                delay: 400,
              });
              // Open cart drawer
              cartDrawer.open();
            } else {
              window.wcmmgTheme.Notification.show({
                target: errorWrapper ? errorWrapper : document.body,
                method: "appendChild",
                type: "success",
                message: wcmmgStrings.itemAdded,
                last: 3000,
                sticky: !errorWrapper,
              });
            }

            window.wcmmgEvents.emit(wcmmgTheme.pubSubEvents.cartUpdate, { cart: response });

            document.dispatchEvent(
              new CustomEvent("product-ajax:added", {
                detail: {
                  product: response,
                },
              })
            );
          } else {
            window.location = wcmmgSettings.routes.cart;
          }
        })
        .then(data => {
          console.log("success");
          // window.location.href = '/cart'; // redirect to cart after success
        })
        .catch((err) => {
          console.error("Error adding items to cart:", err);
          // this._showError("An error occurred while adding items to the cart.", errorWrapper);
        })
        .finally(() => {
          // this.toggleLoading(false, button);
          toggleLoading(false, button); // Stop spinner
        });
    });
  }


  document.querySelectorAll('.bundle-product .variant-options input[type="radio"]').forEach(input => {
    input.addEventListener('change', function () {
      const bundleWrapper = this.closest('.bundle-product');
      const productId = bundleWrapper.dataset.productId;
      const sectionId = bundleWrapper.dataset.sectionId;
      const productHandle = bundleWrapper.dataset.productHandle;
      const variantId = this.value;

      if (!productId || !sectionId || !productHandle || !variantId) return;

      // Build URL using Section Rendering API
      const url = `/products/${productHandle}?section_id=bundle-product-price&variant=${variantId}`;

      fetch(url)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newPriceHTML = doc.querySelector(`#Price-${productId}`);
          const currentPriceBlock = document.querySelector(`#Price-${productId}`);

          if (newPriceHTML && currentPriceBlock) {
            currentPriceBlock.innerHTML = newPriceHTML.innerHTML;
          }
        })
        .catch(error => {
          console.error('Error updating price block:', error);
        });
    });
  });

});



function toggleLoading(isLoading, button) {
  console.log(12);
  if (!button) return;
  const method = isLoading ? 'add' : 'remove';
  button.classList[method]('m-spinner-loading');
}



// cart upsell slider
